const FETCH_PARKING_TICKETS = 'FETCH_PARKING_TICKETS';

const actionTypes = {
  FETCH_PARKING_TICKETS,
};

export default actionTypes;
